import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { getIcon } from "@/lib/iconRegistry";

const DEFAULT_BADGES = [
  { icon: "ShieldCheck", label: "Secure Payments" },
  { icon: "Award", label: "100% Genuine Service" },
  { icon: "Clock", label: "15-30 Min Processing" },
  { icon: "Headset", label: "24x7 Support" },
];

export default function TrustBadges() {
  const [badges, setBadges] = useState(DEFAULT_BADGES);

  useEffect(() => {
    api.get("/site-settings").then((res) => {
      if (res.data.trust_badges?.length) setBadges(res.data.trust_badges);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="trust-badges-section" className="bg-white py-10 border-b border-[#E5E1DA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
        {badges.map((b, i) => {
          const Icon = getIcon(b.icon);
          return (
            <div key={i} data-testid={`trust-badge-${i}`} className="flex flex-col items-center text-center gap-2">
              <div className="w-12 h-12 rounded-full bg-[color-mix(in_oklab,var(--brand-primary),transparent_90%)] flex items-center justify-center">
                <Icon size={22} className="text-[var(--brand-primary)]" />
              </div>
              <span className="text-sm font-medium text-[var(--brand-secondary)]">{b.label}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
